export const GOOGLE_CLIENT_ID = '410937151872-4ctldhqk8pe28c8q4akrsfob2g1mv8mr.apps.googleusercontent.com';
